<template>
  <div>
    <div class="mb-3 d-flex justify-content-end">
      <button @click="$router.push({ name: 'TaskCreate' })" class="btn btn-primary">Добавить <span
          class="hide-450">задание</span></button>
    </div>

    <div v-show="!tasks.length" class="text-center">
      <h3> Нет заданий</h3>
    </div>

    <div class="card  border-0 mb-3" v-for="(task, index)  in tasks" :key="index">
      <TaskPanel :task="task">
      </TaskPanel>
      <div class="card-footer">
        <div class="justify-content-end" style="display: flex;justify-content: right;">
          <div>
            <button v-show="task.status == `CANCELED` || task.status == `REJECTED`"
              @click="$router.push(`/task/${task.id}/review`);" class="btn btn-danger  me-2">
              <i class="fas  fa-circle-exclamation "></i><span class="hide-576 ms-1"> Замечания
                модератора</span></button>
            <button @click="$router.push(`/task/${task.id}/show`);" class="btn btn-info bg-teal-300  me-2"><i
                class="fas fa-circle-info "></i><span class="hide-576 ms-1">Отчет</span> </button>
            <button @click="$router.push(`/task/${task.id}/promote`);" class="btn btn-white  me-2"><i
                class="fas  fa-circle-chevron-up"></i>
              <span class="hide-576 ms-1">Поднять</span></button>
            <button v-show="task.status == `STOPPED` || task.status == `RESERVE`" @click="startTask(task.id);"
              class="btn btn-white  me-2"><i class="fas  fa-circle-play "></i><span
                class="hide-576 ms-1">Запустить</span></button>
            <button v-show="task.status == `PROGRESS`" @click="stopTask(task.id);" class="btn btn-white  me-2"><i
                class="fas fa-circle-pause "></i>
              <span class="hide-576 ms-1">Остановить</span></button>
            <button @click="$router.push(`/task/${task.id}/edit`);" class="btn btn-white  me-2"><i
                class="fas fa-pen-to-square "></i><span class="hide-576 ms-1">Редактировать</span></button>
            <button @click="removeTask(task.id)" class="btn btn-white "><i class="fas fa-trash-can "></i>
              <span class="hide-576 ms-1">Удалить</span></button>
          </div>
        </div>
      </div>
    </div>

    <Paginator :meta="meta" :fetchData="fetchData" />

    <!-- END panel -->
  </div>
</template>


<script>
import HTTP from "../http";
import {show_error, show_message} from "../message";

export default {

  data() {
    return {
      loading: false,
      tasks: [],
      curr_page: 1,
      status: 'ALL',
      meta: {last_page: 1}
    };
  },

  watch: {
    '$route'() {
      this.fetchData(this.$route.params.status.toUpperCase(), this.curr_page);
    }
  },
  mounted() {
    this.fetchData(this.$route.params.status.toUpperCase(), 1);
  },
  methods: {
    removeTask(id) {
      if (confirm("Вы уверены? ")) {
        HTTP()
          .delete("v2/task/" + id)
          .then((response) => {
            console.log(response);
            show_message(this.$notify, response.data);
            this.fetchData();
          })
          .catch((error) => {
            show_error(this.$notify, this.$refs.form, error.response.data)
          });
      }
      return;
    },
    startTask(id) {
      if (confirm("Запустить задание? ")) {
        HTTP()
          .put(`/v2/task/${id}`, {change_status: 'PROGRESS'})
          .then((response) => {
            //this.$router.push(`/tasks/ALL`);
            this.fetchData(this.status, this.curr_page)
            show_message(this.$notify, response.data);
          })
          .catch((error) => {
            show_error(this.$notify, this.$refs.form, error.response.data)
          })
          .finally(() => {
            this.loading = false;
            this.$insProgress.finish();
          });
      }
      return;
    },
    stopTask(id) {
      if (confirm("Остановить задание? ")) {
        HTTP()
          .put(`/v2/task/${id}`, {change_status: 'STOPPED'})
          .then((response) => {
            //this.$router.push(`/tasks/ALL`);
            this.fetchData(this.status, this.curr_page)
            show_message(this.$notify, response.data);
          })
          .catch((error) => {
            show_error(this.$notify, this.$refs.form, error.response.data)
          })
          .finally(() => {
            this.loading = false;
            this.$insProgress.finish();
          });
      }
      return;
    },
    fetchData(page) {
      this.loading = true;
      this.$insProgress.start();
      this.curr_page = page
      HTTP()
        .get(`/v2/task?status=${this.$route.params.status}&page=${page}`)
        .then((resp) => {
          console.log('resp', resp)
          this.tasks = resp.data.data
          this.meta = resp.data.meta
          localStorage.setItem('user', JSON.stringify(resp.data.user))
          window.eventBus.$emit('user.update', resp.data.user)
          this.meta.current_page = !this.meta.current_page ? 1 : this.meta.current_page
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
  }
}
</script>


<style>
.task-href {
  cursor: pointer;
  text-decoration: none;
  color: var(--bs-body-color);
}

.task-href:visited {
  color: var(--bs-body-color);
}

.task-href:hover {
  color: var(--bs-body-color);
}


@media (max-width: 870px) {
  .hide-576 {
    display: none;
  }
}

@media (max-width: 768px) {
  .hide-576 {
    display: inline-block;
    ;
  }
}

@media (max-width: 640px) {
  .hide-576 {
    display: none;
  }
}
</style>